module.exports = __webpack_public_path__ + "img/desktop-wallet.c7e94200.png";